export default __webpack_public_path__ + "static/media/empty-list.053eb301.png";